/**
 * @generated SignedSource<<4dee76129d7edfaf26ae243f57525fa2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BillingIdentityFeaturesPaywall_viewer$data = {
  readonly account: {
    readonly billingAccount: {
      readonly featureAccess: any;
    };
  };
  readonly " $fragmentType": "BillingIdentityFeaturesPaywall_viewer";
};
export type BillingIdentityFeaturesPaywall_viewer$key = {
  readonly " $data"?: BillingIdentityFeaturesPaywall_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"BillingIdentityFeaturesPaywall_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BillingIdentityFeaturesPaywall_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Account",
      "kind": "LinkedField",
      "name": "account",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "BillingAccount",
          "kind": "LinkedField",
          "name": "billingAccount",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "featureAccess",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "e0c65876a263ca7f102fd161c8e24c90";

export default node;
